import Destination from '../components/templates/[destination-id]';

export const DestinationContainer = () => {
  return <Destination />;
};
